import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SlingConfig } from 'src/app/models';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
  selector: 'app-movement-responsibles',
  templateUrl: './movement-responsibles.component.html',
  styleUrls: ['./movement-responsibles.component.scss']
})
export class MovementResponsiblesComponent implements OnInit {

  @Input()
  readonly isNew: boolean;

  @Input()
  readonly slingConfig: SlingConfig

  @Input()
  form: UntypedFormGroup

  searchByCustomer: boolean | null = null;

  constructor(
    private customerService: CustomerService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.slingConfig) {
      this.searchByCustomer = null;
    }

    this.customerService.getOwnersAndAuthorizeds().subscribe({
      next: (response) => {
        console.log('Response de owners-and-authorizeds:', response);
      },
      error: (error) => {
        console.error('Erro ao chamar owners-and-authorizeds:', error);
      }
    });

    const initialCustomer = this.form?.get('customer')?.value;
    if (initialCustomer && initialCustomer.id) {
      this.customerService.getById(initialCustomer.id).subscribe({
        next: (fullCustomerData) => {
          console.log('Dados completos do cliente inicial:', fullCustomerData);

          this.form.patchValue({
            customer: fullCustomerData
          }, { emitEvent: false });

          setTimeout(() => {
            this.cd.detectChanges();
            console.log('Federal ID após inicialização:', this.getFederalId());
          }, 100);
        },
        error: (error) => {
          console.error('Erro ao buscar dados completos do cliente inicial:', error);
        }
      });
    }
  }

  enabledSailor(): boolean {
    return this.slingConfig.hasSailor;
  }

  getFederalId() {
    const customer = this.form?.get('customer')?.value;
    if (!customer) return '';

    const federalId = customer.federalId || '';
    const federalIdType = customer.federalIdType || '';



    return this.formatFederalId(federalId, federalIdType);
  }

  formatFederalId(federalId: string, federalIdType: string): string {
    if (!federalId) return '';

    const numericValue = federalId.replace(/\D/g, '');

    if (federalIdType === 'Physical' && numericValue.length === 11) {
      return numericValue.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }

    if (federalIdType === 'Juridical' && numericValue.length === 14) {
      return numericValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }

    return federalId;
  }

  getFederalIdType() {
    const customer = this.form?.get('customer')?.value;
    if (!customer) return '';

    const federalIdType = customer.federalIdType || '';

    if (federalIdType === 'Physical') {
      return 'CPF';
    } else if (federalIdType === 'Juridical') {
      return 'CNPJ';
    } else if (federalIdType === 'Foreigner') {
      return 'Documento Estrangeiro';
    } else {
      return 'Documento';
    }
  }


}
